module.exports = __webpack_public_path__ + "img/footerp.09f55540.png";